// @flow
import React, { type StatelessFunctionalComponent } from "react";
import { Provider } from "react-redux";
import DocumentTitle from "react-document-title";
import configureStore from "./store";
import List from "../../components/IppList";
import TableActions, { type TableActionsProps } from "../../containers/TablesActions";
import Notification from "../../components/Notification";
import { IPP_LIST_TABLE } from "../../helpers/constants";
import { changeIsActiveSaga, deleteSaga } from "../../actions/tableActions";

const actionsProps: TableActionsProps<typeof IPP_LIST_TABLE> = {
  tableKey: IPP_LIST_TABLE,
  editPath: "/ipp/edit/:id",
  viewPath: "/ipp/view/:id",
  disableDelete: false,
  onDelete: deleteSaga,
  onChangeIsActive: changeIsActiveSaga,
};

const IPPList: StatelessFunctionalComponent<{}> = () => (
  <DocumentTitle title="IPP Motivation Content">
    <Provider store={configureStore()}>
      <List Actions={<TableActions {...actionsProps} />} />
      <Notification />
    </Provider>
  </DocumentTitle>
);

export default IPPList;
